<!-- Card with <a> wrapped and no Action Buttons -->
<script setup lang="ts">
import { MediaProps } from '~/components/cms/Media/Media.vue'
import { actionTransformer, ActionFields } from '~/components/cms/Action/actionHelpers'

export type CardLinkProp = {
  action?: ActionFields
  media?: MediaProps
  title?: string
  text?: string
  preset?: 'icon' /* can have more options in future */
}
const props = withDefaults(defineProps<CardLinkProp>(), {})
const { url, newTab } = actionTransformer(props.action)
</script>

<template>
  <article class="card card--link">
    <Anchor v-if="url" class="card__wrap-link" data-testid="card-link__anchor" :url="url" :new-tab="newTab">
      <div class="card__media">
        <Media v-bind="media" :preset="preset" />
      </div>
      <div class="card__content">
        <h3 class="card__title" v-if="title">{{ title }}</h3>
        <Markdown class="card__text" :content="text" />
      </div>
    </Anchor>

    <div class="card__wrap-no-link" v-if="!url">
      <div class="card__media">
        <Media v-bind="media" :preset="preset" />
      </div>
      <div class="card__content">
        <h3 class="card__title" v-if="title">{{ title }}</h3>
        <Markdown class="card__text" :content="text" />
      </div>
    </div>
  </article>
</template>

<style lang="postcss">
/* Basic styles are inherited from Card.vue > .card */
.card__wrap-link {
  text-decoration: none;
}
</style>
